import type { GridFilterModel } from "@mui/x-data-grid-premium";
import type { UrlFilterModel } from "src/system/useResourceList/useResourceList.types.ts";

export const convertGridFilterModelToUrlFilterModel = (
  model: GridFilterModel,
): UrlFilterModel => {
  return (model.items || [])
    .filter((item) => {
      if (Array.isArray(item.value)) {
        return item.value.length !== 0;
      }
      return item.value != null;
    })
    .reduce((acc, item) => {
      return {
        ...acc,
        [item.field]: {
          v: item.value,
          o: item.operator,
        },
      };
    }, {} as UrlFilterModel);
};
